import React, { ElementType } from "react";
import CustomIcon from "../../CustomIcon/CustomIcon";
import * as Styles from "../CustomTable.styles";
import { SvgIconComponent } from "@mui/icons-material";

interface CustomTableActionButtonProps {
  onClick?: () => void;
  Icon: ElementType | SvgIconComponent;
  size?: string;
  hoverColor?: string;
}

export default function CustomTableActionButton({
  onClick,
  Icon,
  size = "var(--icon-size-md-plus)",
  hoverColor,
}: CustomTableActionButtonProps) {
  return (
    <Styles.ActionIconButton aria-label="action" onClick={onClick} hoverColor={hoverColor}>
      <CustomIcon size={size} Icon={Icon} color="currentColor" />
    </Styles.ActionIconButton>
  );
}
